import Text from 'components/Text'
import { View } from 'components/View'
import React from 'react'

export default function ExerciseChip ({ text }) {
  return (
    <View
      bgc='#F6F6F6'
      mr='1em'
      py='0.295em'
      px='0.7187em'
      style={{ borderRadius: '9px' }}
    >
      <Text fs='0.8em'>
        {text}
      </Text>
    </View>
  )
}
